/**
 * Muscle group config — drives the "Browse by muscle group" tiles
 * and the per-group detail page.
 */
export const MUSCLE_GROUPS = [
  {
    id: "chest",
    label: "Chest",
    tagline: "Press & sculpt your upper body",
    muscles: ["chest"],
    image:
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1600&q=85&auto=format&fit=crop",
  },
  {
    id: "back",
    label: "Back",
    tagline: "Build the V-taper",
    muscles: ["back"],
    image:
      "https://images.unsplash.com/photo-1605296867424-35fc25c9212a?w=1600&q=85&auto=format&fit=crop",
  },
  {
    id: "legs",
    label: "Legs",
    tagline: "Quads, hamstrings, glutes & calves",
    muscles: ["quadriceps", "hamstrings", "glutes", "calves"],
    image:
      "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1600&q=85&auto=format&fit=crop",
  },
  {
    id: "shoulders",
    label: "Shoulders",
    tagline: "Boulder delts and posture",
    muscles: ["shoulders"],
    image:
      "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=1600&q=85&auto=format&fit=crop",
  },
  {
    id: "arms",
    label: "Arms",
    tagline: "Biceps, triceps & forearms",
    muscles: ["biceps", "triceps", "forearms"],
    image:
      "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=1600&q=85&auto=format&fit=crop",
  },
  {
    id: "core",
    label: "Core",
    tagline: "Stability & abdominal strength",
    muscles: ["core"],
    image:
      "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=1600&q=85&auto=format&fit=crop",
  },
  {
    id: "full-body",
    label: "Full Body",
    tagline: "Compound power, head to toe",
    muscles: ["full body"],
    image:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=85&auto=format&fit=crop",
  },
];

export function findGroup(id) {
  return MUSCLE_GROUPS.find((g) => g.id === id);
}
